import {LitElement, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import {hasPimText, pimText} from '../../util/values';
import {setModalActive} from '../../slices/statusSlice';

export class FeatureSelect extends connect(store)(LitElement) {
	static styles = css`
		:host {
		}

		.selectedValue {
			color: var(--color-text-widget-value);
			font-size: var(--font-size-widget-small);
			margin-left: auto;
			max-width: 40%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.info {
			font-family: var(--font-family-light);
			color: var(--color-text-widget-value);
			font-size: var(--font-size-widget-small);
			margin-left: auto;
			padding-right: 0;
			background-color: transparent;
			transition: background-color 0.4s, color 0.4s;
			border: none;
			cursor: pointer;
			text-align: right;
		}

		.info:hover {
			color: var(--color-white);
		}

		.highlight {
			animation: highlight 1.5s ease-out 0s 1 normal forwards;
		}

		@keyframes highlight {
			from {
				border-color: var(--color-white);
			}
			to {
				border-color: var(--color-warn)
			}
		}
    `;

	@property({type: Object})
	feature = {};

	@property({type: Object})
	productData = {};

	@property({type: Boolean})
	hideDisabled = false

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.decisions = state.decisions.data;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;
		this.highlightFeatures = state.status.highlightFeatures;
	}

	getProductData(featureValueId) {
		return this.productData?.values?.find(val => val.valueId === featureValueId);
	}

	hasFeatureDescription() {
		return hasPimText(this.lang, this.feature.variableId, 'F.D', this.decisions, this.translations);
	}
	getFeatureDescription() {
		return pimText(this.lang, this.feature.variableId, 'F.D', this.decisions, this.translations);
	}
	openModal() {
		store.dispatch(setModalActive(
			{
				modalActive: true,
				content: this.getFeatureDescription(),
				title: pimText(this.lang, this.feature.variableId, 'F', this.decisions, this.translations)
			}
		));
	}
	canBeOmitted() {
		// satisfied and only one value available
		return this.isSatisfied() && this.feature.values.filter(value => {
			const key = this.feature.variableId + '.' + value.featureValueId;
			return (key in this.decisions.normalizedDecisions && this.decisions.normalizedDecisions[key].canBeIncluded);
		}).length <= 1;
	}
	selectedFeatureValue() {
		if (this.feature.variableId in this.decisions.normalizedFeatures && this.decisions.normalizedFeatures[this.feature.variableId].selectedValues) {
			return this.decisions.normalizedFeatures[this.feature.variableId].selectedValues;
		} else {
			return [];
		}
	}

	isSatisfied() {
		return (this.feature.variableId in this.decisions.normalizedFeatures && this.decisions.normalizedFeatures[this.feature.variableId].isSatisfied);
	}
	isHighlight() {
		return (this.highlightFeatures && this.highlightFeatures.length > 0 && this.highlightFeatures.includes(this.feature.variableId));
	}


	render() {
	}
}
